import { render, staticRenderFns } from "./RefahBetaManager.vue?vue&type=template&id=ae311292&scoped=true"
import script from "./RefahBetaManager.vue?vue&type=script&lang=js"
export * from "./RefahBetaManager.vue?vue&type=script&lang=js"
import style0 from "./RefahBetaManager.vue?vue&type=style&index=0&id=ae311292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae311292",
  null
  
)

export default component.exports